import Cookies from 'js-cookie'
import store from '../store'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

/**
 * 判断路由和菜单的对应关系
 * @param {*} menus
 * @param {*} route
 */
export function hasPermission(menus, route) {
  if (typeof route.meta !== 'undefined' && route.meta && route.meta.code) {
    return menus.indexOf(route.meta.code) !== -1 || route.children && route.children.length > 0 &&
    route.children.some(child => hasPermission(menus, child))
  } else {
    return true
  }
}

export function hasPermissionRoute(routes, to) {
  const path = to.path
  if (path) {
    const r = routes.filter(item => {
      return item.path === path || item.children && item.children.some(c => {
        const cPath = (item.path + c.path.substr(0, 1) === '/' ? c.path : ('/' + c.path))
        return cPath === path
      })
    })
    return r && r.length > 0
  }
  return false
}

/**
 * 判断用户是否具有特定权限
 * @param {权限信息} perm
 */
export function hasPermissionEx(perm) {
  if (perm && store.getters.menus && store.getters.menus.length > 0) {
    return store.getters.menus.indexOf(perm) !== -1
  }
  return false
}

/**
 * 是否存在对应的权限分类
 * @param {*} route
 * @param {*} type
 */
export function hasPermissionType(routes, type) {
  if (routes) {
    return routes.some(route => route.meta && route.meta.type && type === route.meta.type)
  } else {
    return false
  }
}

/**
 * 是否在特定的分类下有对应的权限
 * @param {*} route
 * @param {*} type
 */
export function hasPermissionInType(routes, type, permCode) {
  if (routes) {
    const typeRouters = routes.filter(route => route.meta && route.meta.type && type === route.meta.type)
    if (typeRouters && typeRouters.length > 0) {
      const typeRouter = typeRouters[0]
      return hasPermission([permCode], typeRouter)
    } else {
      return false
    }
  } else {
    return false
  }
}
/**
 * 是否有操作权限
 */
export function hasOperationPerm(operationPerm) {
  const operationPerms = store.getters.operationPerms
  return operationPerms.indexOf(operationPerm) > -1
}



// WEBPACK FOOTER //
// ./src/utils/auth.js